import { BaseModel, Default } from "@red/data-access";
import { ListFiltersBase } from './list-filters.base';
import { Expose, Transform, Type } from "class-transformer";

export class ScommMatrixTypeCreateDto extends BaseModel {
  @Expose()
  code!: string;

  @Expose()
  @Transform(({ value }) => value.trim())
  name!: string;

  @Expose()
  categoryRole!: string;

  @Expose()
  @Default("")
  description!: string;

  // @Expose()
  // status!: string;

  @Expose()
  @Type(() => Boolean)
  @Default(false)
  isActive!: boolean;
}

export class ScommMatrixTypeUpdateDto extends BaseModel {
  @Expose()
  @Transform(({ value }) => value.trim())
  name!: string;

  @Expose()
  categoryRole!: string;

  @Expose()
  @Default("")
  description!: string;

  @Expose()
  @Type(() => Boolean)
  @Default(false)
  isActive!: boolean;
}


export enum CategoryRole {
  commissionMatrixType = 'commissionMatrixType',
  transactionType = 'transactionType'
}


export class CommMatrixTypeFiltersDto extends ListFiltersBase {
  @Expose()
  categoryRoles!: string;

  @Expose()
  isActive!: boolean;
}
